import { render, staticRenderFns } from "./banl_flow_detail_dialog.vue?vue&type=template&id=62f1b682"
import script from "./banl_flow_detail_dialog.vue?vue&type=script&lang=js"
export * from "./banl_flow_detail_dialog.vue?vue&type=script&lang=js"
import style0 from "./banl_flow_detail_dialog.vue?vue&type=style&index=0&id=62f1b682&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports